/**
 * Поля титульного листа для импорта Markdown. Запоминаются только в этом браузере:
 * вуз, группа и город у студента обычно одни и те же от работы к работе.
 */

import type { TitlePageInfo } from '@gostword/engine';

const STORAGE_KEY = 'gostword.titlePage';

export interface TitlePageForm {
  enabled: boolean;
  info: Required<TitlePageInfo>;
}

const EMPTY: Required<TitlePageInfo> = {
  organization: '',
  workType: '',
  discipline: '',
  topic: '',
  author: '',
  supervisor: '',
  city: '',
  year: '',
};

export function loadTitlePage(): TitlePageForm {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const data = JSON.parse(raw) as { enabled?: unknown; info?: Record<string, unknown> };
      const info = { ...EMPTY };
      for (const key of Object.keys(EMPTY) as Array<keyof TitlePageInfo>) {
        const value = data.info?.[key];
        if (typeof value === 'string') info[key] = value.slice(0, 500);
      }
      // Тема и год у каждой работы свои — их не запоминаем.
      return { enabled: data.enabled !== false, info: { ...info, topic: '', year: '' } };
    }
  } catch {
    // Хранилище недоступно (приватный режим) — поля просто не запомнятся.
  }
  return { enabled: true, info: { ...EMPTY } };
}

export function saveTitlePage(form: TitlePageForm): void {
  try {
    const { topic: _topic, year: _year, ...info } = form.info;
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ enabled: form.enabled, info }));
  } catch {
    // Не критично.
  }
}
